import React from 'react'
import {
    BrowserRouter as Router,
    Link
  } from "react-router-dom";
import classes from './contactInfo.module.scss'

export const ContactInfo = (props) => {
    return (
        <p className={classes.contactInfo}>
            <span>
                <img src={props.image} alt='Icon' />
            </span>
            <Router>
                <Link to={{ pathname: props.url }} 
                    target="_blank">
                    {props.children}
                </Link>
            </Router>
        </p>
    )
}
